import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["spinner"];

  showSpinner() {
    console.log("showSpinner");
    this.spinnerTarget.classList.remove("hidden");
  }

  hideSpinner() {
    console.log("hideSpinner");
    this.spinnerTarget.classList.add("hidden");
  }
}
